<template>
    <div>
        <HeaderBox index="4"></HeaderBox>
        <div class="split"></div>
        <section>
            <article class="fl">
                <ArticleList title="曲径通幽"></ArticleList>
            </article>
            <AsideBox></AsideBox>
        </section>
        <FooterBox></FooterBox>
    </div>
</template>

<script>
import HeaderBox from '../components/HeaderBox'
import ArticleList from '../components/ArticleList'
import AsideBox from '../components/AsideBox'
import FooterBox from '../components/FooterBox'
export default {
    components: {HeaderBox,ArticleList,AsideBox,FooterBox}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/TechnologyView.vue